import {Component, computed, inject, model, ModelSignal} from '@angular/core';
import {
  FormElementComponent
} from "frontier/browserkit/src/lib/components/control/form-control/dynamic-form/form-element/form-element.component";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatDivider} from "@angular/material/divider";
import {
  DynamicFormActionComponent
} from "frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-action/dynamic-form-action.component";
import {FormBuilder, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IAction} from "frontier";
import {
  CustomDynamicFormComponent
} from "frontier/browserkit/src/lib/components/control/form-control/dynamic-form/custom-dynamic-form/custom-dynamic-form.component";
import AppControlGuids from "../../../../api/ControlGuids";
import {
  JSON_EXPORT_ACTION,
  JSON_IMPORT_ACTION
} from "frontier/browserkit/src/lib/components/control/table-control/default-form-actions.constant";
import {
  DebitorAccountHelpComponent
} from "../booking-options-config-form/debitor-account-help/debitor-account-help.component";
import {UiHelperService} from "frontier/browserkit/src/lib/components/ui-helper/ui-helper.service";
import {HelpIconComponent} from "frontier/browserkit/src/lib/components/help-icon/help-icon.component";

enum EFormKeys {
  depositor = 'tsepaconfig;0',
  iban = 'tsepaconfig;1',
  bic = 'tsepaconfig;2',
  creditorId = 'tsepaconfig;3',
  purpose = 'tsepaconfig;4',
}

@Component({
  selector: 'app-sepa-config-form',
  standalone: true,
  imports: [
    FormElementComponent,
    MatProgressBar,
    MatDivider,
    DynamicFormActionComponent,
    FormsModule,
    ReactiveFormsModule,
    HelpIconComponent,
  ],
  templateUrl: './sepa-config-form.component.html',
  styleUrl: './sepa-config-form.component.scss'
})
export class SepaConfigFormComponent extends CustomDynamicFormComponent {
  EFormKeys: typeof EFormKeys = EFormKeys;
  override GUID: string = AppControlGuids.TSepaConfigForm;
  override actions: ModelSignal<IAction[]> = model<IAction[]>([
    JSON_EXPORT_ACTION,
    JSON_IMPORT_ACTION,
  ]);

  _uiHelperService: UiHelperService = inject(UiHelperService);

  fb: FormBuilder = inject(FormBuilder);

  formData = {
    depositor: computed(() => this.getFormElementByKey(EFormKeys.depositor)),
    iban: computed(() => this.getFormElementByKey(EFormKeys.iban)),
    bic: computed(() => this.getFormElementByKey(EFormKeys.bic)),
    creditorId: computed(() => this.getFormElementByKey(EFormKeys.creditorId)),
    purpose: computed(() => this.getFormElementByKey(EFormKeys.purpose)),
  }

  showHelpForSepa() {
    this._uiHelperService.openHelp({component: DebitorAccountHelpComponent})
  }
}
